module.exports = __webpack_public_path__ + "static/paris-008.thumb-692b130d9fc6485250d05a0477e20642.jpg";